import { LinkPTComponentInterface } from '@/src/assets/interfaces/linkPTInterface';
import { getRel } from '@/src/assets/utils/getRel';
import { isBlank } from '@/src/assets/utils/isBlank';

import styles from './LinkPTComponent.module.scss';

const LinkPTComponent = ({ children, value }: LinkPTComponentInterface) => {
    if (!value || !value.url) {
        return '';
    }

    const rel = getRel(value?.relOverride, value?.url ? value.url : '');
    const isBlankValue = isBlank(value?.url ? value.url : '', value?.isBlank)
        ? '_blank'
        : undefined;
    return (
        <a className={styles.postLink} href={value?.url} rel={rel} target={isBlankValue}>
            {children}
        </a>
    );
};

export { LinkPTComponent };
